// extracted by mini-css-extract-plugin
module.exports = {"media":"footer-module--media--2algY","copyright":"footer-module--copyright--_WaUO"};